import { View } from "react-native";

type SectionCardProps = Readonly<{
  children: React.ReactNode;
}>;

export const SectionCard = ({ children }: SectionCardProps) => (
  <View className="rounded-2xl bg-chalk p-4 md:border md:border-ash-3">
    {children}
  </View>
);
